import { getUserProfile, hasCRMCommlinkAccess } from './AuthUtil';

const hasCommlinkAccess = hasCRMCommlinkAccess(getUserProfile());

export const isCommLinkFeatureFlagEnabled = (state: IReduxStore) =>
  (state.productLayout.productLayout?.agency?.agencyInfo?.isCommLinkFeatureFlagEnabled ?? false) && hasCommlinkAccess;

export const isAccountsFeatureFlagEnabled = (state: IReduxStore) =>
  state.productLayout.productLayout?.agency?.agencyInfo?.isAccountsFeatureFlagEnabled ?? false;
